import withUserData from "../../../../shared/seller-services/traits/withUserData";

class UserDataStore {}

export default withUserData(UserDataStore);
